import { render } from "./gserver.vue?vue&type=template&id=47c5c7ee&scoped=true"
import script from "./gserver.vue?vue&type=script&lang=js"
export * from "./gserver.vue?vue&type=script&lang=js"

import "./gserver.vue?vue&type=style&index=0&id=47c5c7ee&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c5c7ee"]])

export default __exports__